import React, { Component } from 'react';
import Table from '../../../../../components/_table/Table/Table';
import Panel from '../../../../../components/outline/Panel';
import { comparePrePropsAndNextProps } from '../../../../../lib/common';
import { columns } from './columns';
import './RecommendReviewDetailItemList.scss';

class RecommendReviewDetailItemList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps, nextState) => {
    return comparePrePropsAndNextProps([
      [nextProps, this.props],
      [nextState, this.state],
    ]);
  };

  render() {
    const { recommendReviewItemList } = this.props;

    return (
      <Panel className="recommend-review-detail-item-list">
        <div className="panel-header">
          <div className="title">추천 상품 후기 아이템 리스트</div>
        </div>

        <div className="panel-body">
          <Table
            columns={columns}
            rowKey={(record) => record.id}
            list={recommendReviewItemList}
            size="small"
            scroll={{ x: true }}
            bordered={true}
          />
        </div>
      </Panel>
    );
  }
}

export default RecommendReviewDetailItemList;
